import styled from "styled-components"

import { useQuery, useQueryClient } from 'react-query';
import React, { useEffect, useState } from "react";
import Menu from "../components/common/Menu";
import theme from "../styles/theme";
import Navigator from "../components/common/Navigator";
import { useGetMenuStatus } from "../interfaces/common";
import CommonModal from "../components/common/CommonModal";
import { useGetModalInfo } from "../interfaces/modal";

const MainWrap = styled.div`
    position: relative;
    width: 100%;
    height: 100vh;
    background: #E5E5E5;
    display:grid;
    grid-template-columns: ${(props)=>props.open ? '200px' : '0px'} auto;
    transition: ${theme.windowSize.drawerTransition};
`;

const MainBody = styled.div`
    overflow: auto;
`;

const DashboardTemplate = ({target}) => {

    const { data : menuStatus } = useGetMenuStatus();
    const { data : modalInfo } = useGetModalInfo();

    return (
        <MainWrap open={menuStatus!==undefined?menuStatus:true}>
            <Menu/>
            <MainBody>
                <div>
                    {target}
                </div>
            </MainBody>
            {(modalInfo && modalInfo.show ===true ) && <CommonModal modalInfo={modalInfo}/>}
        </MainWrap>
    )

}

export default DashboardTemplate;